import { Category, StoreCategories } from 'common/types/entities/store'
import { fetchStoreCategories } from 'common/services/channel'
import { CommonState } from 'common/types'
import { StateKey } from 'common/utils/flipState'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: StoreCategories = {
  categories: null,
  selectedCategory: null,
  selectedSubCategory: null,
  inquiryCategory: null,
  storeId: null,
  brandId: null,
  cacheParam: null,
}

const FETCH = '/store/general/category/FETCH'
const FETCH_BRAND_CATEGORY = '/store/general/category/FETCH_BRAND_CATEGORY'
const RESTORE_ALL = '/store/general/category/SET_ALL'
const SET = '/store/general/category/SET'
const SET_SUB = '/store/general/category/SET_SUB'

export const fetchCategories = (curState: StateKey, inquiryStoreId: string, queryParams?: any) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const brandId = queryParams && queryParams['brandId'] ? queryParams['brandId'] : null
  const categoryId = queryParams && queryParams['category'] ? queryParams['category'] : null
  const subCategoryId = queryParams && queryParams['subCategory'] ? queryParams['subCategory'] : null

  const cacheParam = createCacheParam(FETCH, 'fetchCategories', { curState, inquiryStoreId, queryParams })
  if (isCacheHit(getState().storeCategories[curState], cacheParam)) {
    return
  }

  const categories = await fetchStoreCategories(inquiryStoreId, brandId)
  const selectedCategory = categories.find(category => category.id === categoryId)
  const selectedSubCategory =
    selectedCategory && selectedCategory.children && selectedCategory.children.length > 0
      ? selectedCategory.children.find(category => category.id === subCategoryId) || selectedCategory.children[0]
      : null

  dispatch({
    curState,
    cacheParam,
    type: FETCH,
    payload: {
      categories,
      selectedSubCategory,
      brandId,
      storeId: inquiryStoreId,
      selectedCategory: selectedCategory || (categories && categories.length && categories[0]) || null,
      inquiryCategory:
        selectedSubCategory || selectedCategory || (categories && categories.length && categories[0]) || null,
    },
  })
}

export const fetchBrandCategories = (curState: StateKey, storeId: string, brandId: string) => async dispatch => {
  const categories = await fetchStoreCategories(storeId, brandId)
  dispatch({
    curState,
    categories,
    storeId,
    selectedCategory: (categories && categories.length && categories[0]) || null,
    inquiryCategory: (categories && categories.length && categories[0]) || null,
    type: FETCH_BRAND_CATEGORY,
  })
}

export const setCategory = (curState: StateKey, category: Category) => {
  return {
    curState,
    type: SET,
    payload: category,
  }
}

export const setSubCategory = (curState: StateKey, subCategory: Category) => {
  return {
    curState,
    type: SET_SUB,
    payload: subCategory,
  }
}

// Reducer
const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...action.payload,
        cacheParam: action.cacheParam,
      }
    case FETCH_BRAND_CATEGORY: {
      return {
        cacheParam: null,
        ...action,
      }
    }
    case SET:
      return {
        ...state,
        cacheParam: null,
        selectedCategory: action.payload,
        inquiryCategory: action.payload,
        selectedSubCategory: action.payload.children.length ? action.payload.children[0] : null,
      }
    case SET_SUB:
      return {
        ...state,
        cacheParam: null,
        selectedSubCategory: action.payload,
        inquiryCategory: action.payload,
      }
    case RESTORE_ALL:
      return {
        cacheParam: null,
        ...action.state,
      }
    default:
      return state
  }
}

export default categoriesReducer
